module.exports = __webpack_public_path__ + "img/627.Selver_spone.33b68cbd.svg";